module.exports = __webpack_public_path__ + "img/maker_kang-e.d279c7e4.jpg";